module.exports = __webpack_public_path__ + "img/9.87c9409c.jpg";